<template>
  <div class="bind-product-modal">
    <el-dialog
      title="重新绑定商品"
      v-model="visible"
      custom-class="bind-product"
      @close="onClose()"
    >
      <div class="dialog-header">
        <div class="header-title">重新绑定商品</div>
        <div class="subtitle">* 如对绑定商品有疑问，请及时联系签证专家沟通确认</div>
        <div class="icon-close" @click="visible = false">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div class="dialog-body">
        <el-form>
          <div class="main-item-box" v-if="otaOrderInfo">
            <div class="box-header">
              <span class="header-title">飞猪商品信息</span>
            </div>
            <div class="box-body">
              <div class="body-field">
                <label class="field-label">商品信息</label>
                <p class="field-content">{{otaOrderInfo.item_title}}</p>
              </div>
              <div class="body-field">
                <label class="field-label">套餐信息</label>
                <p class="field-content">{{otaOrderInfo.sku_properties}}</p>
              </div>
              <div class="body-field">
                <label class="field-label">出签形式</label>
                <p class="field-content">{{otaOrderInfo.visa_type}}</p>
              </div>
            </div>
          </div>
          <el-form-item label="" :class="{ 'has-error': errmsg }">
            <el-select
              class="product-select"
              v-model="selectedProductId"
              filterable
              remote
              clearable
              placeholder="请输入上上签商品编号或商品名称"
              :remote-method="searchProduct"
              :loading="loading"
              size="large"
              @change="changeProduct"
            >
              <el-option
                v-for="item in productList"
                :key="item.visa_product_id"
                :label="'【' + item.visa_product_id + '】' + item.product_name"
                :value="item.visa_product_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="err-tips">{{ errmsg }}</div>
        <button
          type="primary"
          @click="bindProduct"
          :disabled="!!errmsg || !selectedProductId"
          class="save-button s-btn btn-blue btn-lg"
          >确定</button
        >
      </div>

      
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/libs/utils';
import Http from '@/libs/http';

export default {
  components: {},
  data() {
    return {
      params: {
        ota_sub_order_id: 0,
        resolve: null,
        reject: null,
        onClose: null,
      },
      visible: false,
      otaOrderInfo: null,
      loading: false, // 选项加载状态
      selectedProductId: '', // 选中商品id
      productList: [], // 商品列表
      errmsg: '', // 错误提示
      isSuccess: false,
    };
  },
  created() {
    this.visible = true;
    this.init();
  },
  methods: {
    init() {
      if (!this.params.ota_sub_order_id) {
        this.visible = false;
        return;
      }
      this.getOtaOrder();

    },
    getOtaOrder() {
      return Http.post('/ota_order_query', { ota_sub_order_id: this.params.ota_sub_order_id }).then((data) => {
        this.otaOrderInfo = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 关闭
    onClose() {
      if (this.isSuccess) {
        this.params.resolve && this.params.resolve();
      } else {
        this.params.reject && this.params.reject();
      }
      // 销毁弹窗
      setTimeout(() => {
        this.params.onClose && this.params.onClose();
        this.$destroy(true);
        if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el);
      }, 300);
    },

    // 查询商品列表
    searchProduct(query) {
      if (query !== '') {
        this.loading = true;
        Http.post('/visa_product_search', { keyword: query })
          .then((data) => {
            this.productList = data.product;
            this.loading = false;
          })
          .catch((e) => {
            if (e) console.log(e);
            this.productList = [];
          });
      } else {
        this.productList = [];
      }
    },

    // 选中商品时验证是否合规
    changeProduct(id) {
      if (!id) {
        return;
      }
      Http.post(
        '/ota_order_product_detect',
        { ota_sub_order_id: this.params.ota_sub_order_id, visa_product_id: id },
        { noToast: true },
      )
        .then(() => {
          this.errmsg = '';
        })
        .catch((e) => {
          if (e) console.log(e);
          this.errmsg = e.msg;
        });
    },

    // 提交
    bindProduct() {
      if (this.errmsg || !this.selectedProductId) {
        return;
      }
      
      Http.post('/ota_order_product_bind', {
        ota_sub_order_id: this.params.ota_sub_order_id,
        visa_product_id: this.selectedProductId,
      })
        .then(() => {
          utils.msg.success('绑定成功');
          this.isSuccess = true;
          this.visible = false;
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.err-tips {
  color: #ff5a60;
  margin-top: -12px;
  height: 16px;
}

.save-button {
  margin: 20px auto 0;
  display: block;
  width: 240px;
  height: 48px;
  border-radius: 4px;
}
.bind-product-modal {
  /deep/ .bind-product {
    width: 800px;
    top: 50% !important;
    transform: translate(-50%, -50%);
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}

.el-select-dropdown {
  .el-select-dropdown__item {
    white-space: normal;
    height: auto;
    width: 450px;
  }
}

/deep/ .has-error .el-form-item__label {
  color: rgb(72, 84, 106);
}


.dialog-header{
  height: 62px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  border-bottom: 1px solid #E9EEF2;
  position: relative;
  .header-title{
    color: #2F333D;
    font-size: 20px;
    font-weight: 600;
  }
  .subtitle{
    margin-left: 10px;
    font-size: 14px;
    line-height: 20px;
    color: #AAAAAA;
  }
  .icon-close{
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    color: #91999F;
    cursor: pointer;
  }
}

.dialog-body{
  padding: 24px 24px 32px 24px;
  .el-form-item__content {
    line-height: 1;
  }
  .product-select {
    width: 450px;
    height: 36px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #aaa;
    ::-webkit-input-placeholder {
      /* WebKit browsers */
      color: #aaa;
    }
    :-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #aaa;
    }
    ::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #aaa;
    }
    :-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color: #aaa;
    }
  }
  .bottom-btns {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    button {
      width: 200px;
      height: 40px;
    }
    .cancel-button {
      border: 1px solid #e3e3e3;
      color: #777;
    }
  }
}

.main-item-box {
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.1);
  border-radius: 4px;
  border: solid 1px #f0f0f0;
  .box-header {
    padding: 0 10px 0 20px;
    height: 52px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
    .header-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      .header-subtitle {
        margin-left: 15px;
        font-size: 14px;
        font-weight: normal;
        color: #aaa;
      }
    }
    .header-right{
      display: flex;
      align-items: center;
      .error-tips{
        padding: 0 20px 0 24px;
        height: 40px;
        line-height: 40px;
        color: #ff5a60;
        font-size: 14px;
        background-image: url('https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/order/fliggy/icon-error-tips.png');
        background-repeat: no-repeat;
        background-size: 16px 16px;
        background-position: left center;
      }
      .s-btn{
        height: 28px;
        border: 4px;
        padding: 0 12px;
      }
    }
  }
  .box-body {
    padding: 20px;
    .body-field {
      display: flex;
      margin-bottom: 10px;
      &:last-child{
        margin-bottom: 0;
      }
      .field-label {
        width: 108px;
        color: #777;
        font-size: 14px;
        line-height: 24px;
        flex-grow: 0;
        flex-shrink: 0;
      }

      .field-content {
        font-size: 14px;
        line-height: 24px;
        color: #2F333D;
        word-break: break-all;
        .content-subtitle {
          color: #aaa;
          margin-right: 10px;
          &.left-border::before {
            content: "";
            display: inline-block;
            vertical-align: middle;
            width: 1px;
            height: 16px;
            background-color: #cfcfcf;
            margin-right: 20px;
            margin-left: 20px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ota/fliggy-rebind-product-dialog/fliggy-rebind-product-dialog.vue